import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'src/components/ui'

interface IServerUnavailable {
  onRetry: () => void
}

// Shown when the account cannot be loaded because the server is unreachable,
// instead of treating the user as signed out.
const ServerUnavailable: FC<IServerUnavailable> = ({ onRetry }) => {
  const { t } = useTranslation()
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-4 min-h-[60vh] px-4 text-center"
    >
      <p className="text-lg font-semibold text-ink">{t('errors.SERVER')}</p>
      <Button className="!w-auto px-6" onClick={onRetry}>
        {t('retry')}
      </Button>
    </div>
  )
}

export default ServerUnavailable
